import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  aligned: {
    alignItems: 'center',
    gap: theme.new.spacing.medium,
  },
  header: {
    justifyContent: 'space-between',
    paddingBottom: theme.new.spacing.medium,
  },
  logo: {
    height: 24,
    width: 'auto',
  },
}));

export default useStyles;
